export default __webpack_public_path__ + "static/media/chain-2.a13d1c48.png";